import { DateTimeStr } from '@mi-front/core';
import { LocaleRelativeTime } from '@mi-front/ui';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { LDate } from './LDate';
import { LTime } from './LTime';

const ONE_MINUTE_MS = 60 * 1000;

interface Props {
  value: DateTimeStr | string;
  showRelative?: boolean | 'inline';
  showSeconds?: boolean;
}

/** Returns true when the given date is less than one minute in the past. */
function isLessThanOneMinuteAgo(date: Date): boolean {
  return Date.now() - date.getTime() < ONE_MINUTE_MS;
}

export const LDateTime = (p: Props) => {
  const { value, showSeconds = false } = p;
  const { formatMessage: $t } = useIntl();
  const date = new Date(value);

  if (isLessThanOneMinuteAgo(date)) {
    return (
      <Box display="inline-flex" flexDirection="column">
        {$t({
          id: 'date.justNow',
          defaultMessage: 'Hace instantes',
        })}
      </Box>
    );
  }

  return (
    <Box display="inline-flex" flexDirection="column">
      <Box display="flex" gap={0.75}>
        <LDate value={value as DateTimeStr} day="2-digit" month="2-digit" year="2-digit" />
        <LTime value={value as DateTimeStr} showSeconds={showSeconds} />

        {p.showRelative && p.showRelative === 'inline' && (
          <>
            (<LocaleRelativeTime value={value} />)
          </>
        )}
      </Box>

      {p.showRelative && p.showRelative !== 'inline' && (
        <Typography color="text.disabled" fontSize="0.7rem">
          <LocaleRelativeTime value={value} />
        </Typography>
      )}
    </Box>
  );
};
